function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AssetComponent from "components/core/asset/asset-component";
import { useState, useRef } from "react";
import classnames from "classnames";
import { trackEvent } from "services/bigbrain-service";
import { PLATFORM_INTERACTIVE_EXPERIENCE_INTERACTION_CLICKED, PLATFORM_INTERACTIVE_EXPERIENCE_INTERACTION_TAG_CLICKED, PLATFORM_INTERACTIVE_EXPERIENCE_BACK_BUTTON_CLICKED } from "constants/bigbrain-event-types";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import PlatformInteractionComponent from "../platform-iteraction/platform-interaction-component";
import NavMenuComponent from "../nav-menu/nav-menu-component";
import { StyledPlatformInteractiveExperienceHomepageFirstFoldComponent } from "./platform-interactive-experience-homepage-first-fold-desktop-component.scss";
import { SYSTEM_BACKGROUND_IMG_SRC } from "../../consts";
const PlatformInteractiveExperienceHomepageFirstFoldDesktopComponent = (props)=>{
    const { interactions, rippleEffectAnimationDuration, glowImage, backgroundImage, backgroundSize, segmentHeight, segmentMaxHeight } = props;
    const [currentInteraction, setCurrentInteraction] = useState(-1);
    const infoSectionRef = useRef(null);
    const onBackButtonClick = ()=>{
        trackEvent(PLATFORM_INTERACTIVE_EXPERIENCE_BACK_BUTTON_CLICKED);
        setCurrentInteraction(-1);
    };
    const onInteractionClick = (index)=>{
        var _infoSectionRef_current_getBoundingClientRect, _infoSectionRef_current, _interactions_index;
        const y = (infoSectionRef === null || infoSectionRef === void 0 ? void 0 : (_infoSectionRef_current = infoSectionRef.current) === null || _infoSectionRef_current === void 0 ? void 0 : (_infoSectionRef_current_getBoundingClientRect = _infoSectionRef_current.getBoundingClientRect()) === null || _infoSectionRef_current_getBoundingClientRect === void 0 ? void 0 : _infoSectionRef_current_getBoundingClientRect.top) + window.scrollY - 100;
        if (y) {
            window.scrollTo({
                top: y,
                behavior: "smooth"
            });
        }
        trackEvent(PLATFORM_INTERACTIVE_EXPERIENCE_INTERACTION_CLICKED, {
            kind: (_interactions_index = interactions[index]) === null || _interactions_index === void 0 ? void 0 : _interactions_index.label
        });
        setCurrentInteraction(index);
    };
    const onInteractionTagClick = (index)=>{
        var _interactions_index;
        trackEvent(PLATFORM_INTERACTIVE_EXPERIENCE_INTERACTION_TAG_CLICKED, {
            kind: (_interactions_index = interactions[index]) === null || _interactions_index === void 0 ? void 0 : _interactions_index.label
        });
        setCurrentInteraction(index);
    };
    return /*#__PURE__*/ _jsxs(StyledPlatformInteractiveExperienceHomepageFirstFoldComponent, {
        className: "platform-interactive-experience-homepage-first-fold-component",
        isInteractionActive: currentInteraction >= 0,
        segmentHeight: segmentHeight,
        segmentMaxHeight: segmentMaxHeight,
        glowWidth: glowImage === null || glowImage === void 0 ? void 0 : glowImage.width,
        glowPositionTop: glowImage === null || glowImage === void 0 ? void 0 : glowImage.positionTop,
        glowPositionLeft: glowImage === null || glowImage === void 0 ? void 0 : glowImage.positionLeft,
        backgroundSize: backgroundSize,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "info-section-wrapper",
                ref: infoSectionRef,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: classnames("info-section", {
                        active: currentInteraction >= 0
                    }),
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "back-botton",
                            onClick: onBackButtonClick,
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "back-arrow",
                                    children: "<"
                                }),
                                " ",
                                " Back"
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "info-content-wrapper",
                            children: interactions === null || interactions === void 0 ? void 0 : interactions.map((interaction, index)=>{
                                var _interaction_content;
                                return /*#__PURE__*/ _jsx("div", {
                                    className: classnames("info-content", {
                                        active: currentInteraction === index
                                    }),
                                    children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread_props(_object_spread({}, interaction === null || interaction === void 0 ? void 0 : interaction.content), {
                                        buttonConfig: _object_spread_props(_object_spread({}, interaction === null || interaction === void 0 ? void 0 : (_interaction_content = interaction.content) === null || _interaction_content === void 0 ? void 0 : _interaction_content.buttonConfig), {
                                            extraData: {
                                                platformTab: interaction === null || interaction === void 0 ? void 0 : interaction.label
                                            }
                                        })
                                    }))
                                });
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "interactive-section-wrapper",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "interactive-section",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "glow",
                            children: /*#__PURE__*/ _jsx(AssetComponent, {
                                image: {
                                    src: glowImage === null || glowImage === void 0 ? void 0 : glowImage.src
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "system-layout-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx(NavMenuComponent, {
                                    className: classnames("interactions-nav-menu", {
                                        active: currentInteraction >= 0
                                    }),
                                    interactions: interactions,
                                    currentInteraction: currentInteraction,
                                    onInteractionClick: onInteractionTagClick
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "system-layout",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "system-background",
                                            children: /*#__PURE__*/ _jsx(AssetComponent, {
                                                image: {
                                                    src: backgroundImage || SYSTEM_BACKGROUND_IMG_SRC
                                                }
                                            })
                                        }),
                                        interactions === null || interactions === void 0 ? void 0 : interactions.map((interaction, index)=>{
                                            return /*#__PURE__*/ _jsx(AssetComponent, _object_spread({
                                                className: classnames("system-action-wrapper", {
                                                    show: currentInteraction === index,
                                                    hide: currentInteraction !== index
                                                })
                                            }, interaction.actionAsset));
                                        })
                                    ]
                                })
                            ]
                        }),
                        interactions === null || interactions === void 0 ? void 0 : interactions.map((interaction, index)=>{
                            return /*#__PURE__*/ _jsx(PlatformInteractionComponent, {
                                className: classnames("platform-interaction", {
                                    show: currentInteraction < 0,
                                    hide: currentInteraction >= 0
                                }),
                                isRippleEffectOn: true,
                                image: interaction.image,
                                icon: interaction.icon,
                                label: interaction.label,
                                position: interaction.position,
                                rippleEffectAnimationDuration: rippleEffectAnimationDuration,
                                onInteractionClick: ()=>onInteractionClick(index)
                            }, index);
                        })
                    ]
                })
            })
        ]
    });
};
export default PlatformInteractiveExperienceHomepageFirstFoldDesktopComponent;
